import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.slice(1)).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    api
      .get("/auth/google/session", { params: { session_id: sessionId } })
      .then(({ data }) => {
        window.history.replaceState(null, "", "/");
        setUser(data);
        navigate("/", { replace: true, state: { user: data } });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-callback-loading">
      <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
    </div>
  );
}
